import { QCONTINUITY_ENTITY } from "app/shared/constant";
import { CommonSectionIds } from "../common.models";


export const ForesiteXDSectionIds = {
    BasicInfo: CommonSectionIds.BasicInfo,
    DataDelivery: CommonSectionIds.DataDelivery,
    ConfigureAlarms: CommonSectionIds.ConfigureAlarms,
    DialogActions: CommonSectionIds.DialogActions,

    ForeSiteXdInfo: 'foresite-xd-info-section',
    RadarSensor: 'foresite-radar-sensor-section',
}

export enum ForeSITEXDDataDeliveryFieldIds {
    NormalIntervalHours = 'fore-site-xd-normalIntervalHours',
    FastModeEnabled = 'fore-site-xd-fastModeEnabled'
}

export enum ForeSiteXDalarmsFieldIds {
    LowLevelEnable = 'fore-site-xd-lowLevelEnable',
    LowLevelThreshold = 'fore-site-xd-lowLevelThreshold',
    HighLevelEnable = 'fore-site-xd-highLevelEnable',
    HighLevelThreshold = 'fore-site-xd-highLevelThreshold',
    HighHighEnable = 'fore-site-xd-highHighEnable',
    HighHighThreshold = 'fore-site-xd-highHighThreshold',
    BatteryLowEnable = 'fore-site-xd-batteryLowEnable',
    BatteryLowThreshold = 'fore-site-xd-batteryLowThreshold',
}

export enum ForeSiteRadarSensorFieldIds {
    MaxMeasurementRange = 'fore-site-xd-maxMeasurementRange',
    MaxRangeWarning = 'fore-site-xd-maxRangeWarning',
    PhysicalOffset = 'fore-site-xd-physicalOffset',
    Name = 'fore-site-xd-name',
}

export const ForeSITEXD_CONSTANTS = {
    apnProvider: 'ADSENV.COM',
    fastrate: 300,
    qFinalEntityID: QCONTINUITY_ENTITY,
}

export const INSTALLATION_DEFAULT_CONSTANTS = {
    installationDesc1: '',
    installationDesc2: '',
    installationDesc3: '',
    installationDesc4: '',
    installationDesc5: '',
    wasCreatedFromImport: false,
}

export const FORESITE_XD_MONITOR_CONFIGURATION_CONSTANTS = {
    ftpdeliverynormal: 0,
    ftpdeliveryfast: 0,
    ftpfolder: '',
    ftppassword: '',
    ftpusername: '',
    ftpserver: '',
    ftpmode: 'Active',
    ftpformat: 'ADS',
    storetemperature: false,
    storebattery: 1,
}